import React, { useState } from "react";

const data = [
  {
    title: "Epub Preflight",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Reports",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Epub Checker 4.1.1",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Epub Checker 4.2.6",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Epub Checker 5.0.0",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Epub Checker 5.1.0",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "Flightcrew",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
  {
    title: "ACE Report",
    error: [
      "Validating against EPUB version 3.0",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/content.opf(10,44): Undefined property: source-of",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/13_Chapter_02.xhtml(143,30): Undefined property: summary",
      "ERROR: d:/Mathan/PERL/Working_folder/Epub-Accessibility/Epub-Validation/9780335249688_EPUB.epub/OEBPS/Text/15_Chapter_04.xhtml(607,30): Undefined property: summary",
    ],
  },
];

const Validationreport = () => {
  const [index, setIndex] = useState(0);

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">ePub Validation Report</h1>
        </div>
        <div className="flex shadow-commonshadow rounded-[16px] bg-white">
          <div className="w-3/12 flex flex-col text-left p-6 border-r-[1px] border-bordercommon">
            <h className="text-18 text-title font-semibold">Reports</h>
            <div className="p-6">
              <ol className="flex flex-col gap-2">
                {data.map((list, i) => (
                  <li
                    onClick={() => setIndex(i)}
                    key={i}
                    className={`${
                      index === i
                        ? "bg-bluebg text-white font-semibold"
                        : "bg-white text-title"
                    } px-2 py-3 cursor-pointer rounded-[12px]`}
                  >
                    {`${i + 1}. ${list.title}`}
                  </li>
                ))}
              </ol>
            </div>
          </div>
          <div className="w-8/12 text-left p-6">
            <h className="text-18 text-title font-semibold">Errors</h>
            <div className="px-6 py-0 my-6 h-[60vh] overflow-auto">
              <ul className="list-disc flex flex-col gap-2">
                {data[index].error.map((errors, i) => (
                  <li key={i}>{errors}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Validationreport;
